import React, { useState, useEffect, useRef, useCallback } from 'react';

function Contact() {
    console.log('🔵 Contact 컴포넌트 렌더링됨');
    
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [formMessage, setFormMessage] = useState({ text: '', type: '' });
    const cardsRef = useRef([]);

    const renderMap = useCallback(() => {
        console.log('🎨 renderMap 호출됨');
        if (!window.kakao || !window.kakao.maps) {
            console.error('❌ window.kakao 또는 window.kakao.maps가 없습니다');
            console.error('window.kakao:', window.kakao);
            return;
        }

        console.log('✅ window.kakao.maps 확인됨');
        try {
            window.kakao.maps.load(() => {
                console.log('🗺️ kakao.maps.load 콜백 실행');
                const mapContainer = document.getElementById('map');
                if (!mapContainer) {
                    console.error('❌ id="map" 요소를 찾을 수 없습니다');
                    return;
                }
                console.log('✅ map 컨테이너 찾음:', mapContainer);

                const mapOption = {
                    center: new window.kakao.maps.LatLng(35.289026, 126.9958567),
                    level: 3
                };
                console.log('🗺️ 지도 생성 중...');
                const map = new window.kakao.maps.Map(mapContainer, mapOption);
                console.log('✅ 지도 생성 완료');

                const markerPosition = new window.kakao.maps.LatLng(35.289026, 126.9958567);
                const marker = new window.kakao.maps.Marker({
                    position: markerPosition
                });
                marker.setMap(map);
                console.log('📍 마커 추가 완료');

                const infowindow = new window.kakao.maps.InfoWindow({
                    content: '<div style="padding:5px;font-size:12px;">GraceTech(은혜테크)</div>'
                });
                infowindow.open(map, marker);
                console.log('💬 인포윈도우 추가 완료');
            });
        } catch (error) {
            console.error('❌ 지도 렌더링 중 에러:', error);
        }
    }, []);

    const loadKakaoMapSDK = useCallback((apiKey) => {
        console.log('📦 SDK 로드 함수 호출');
        console.log('🔑 받은 API Key:', apiKey);
        console.log('🔑 API Key 길이:', apiKey ? apiKey.length : 0);
        
        if (!apiKey || apiKey.trim() === '') {
            console.error('❌ API 키가 비어있습니다!');
            return;
        }
        
        // 이미 로드된 경우
        if (window.kakao && window.kakao.maps) {
            console.log('✅ Kakao SDK 이미 로드됨');
            renderMap();
            return;
        }

        // 이미 스크립트 태그가 존재하는지 확인
        const existingScript = document.querySelector('script[src*="dapi.kakao.com"]');
        if (existingScript) {
            console.log('⏳ Kakao SDK 스크립트가 이미 로딩 중입니다');
            console.log('기존 스크립트 src:', existingScript.src);
            // 스크립트가 로드되기를 기다림
            existingScript.addEventListener('load', () => {
                console.log('✅ 기존 스크립트 로드 완료');
                renderMap();
            });
            return;
        }

        console.log('📥 Kakao SDK 스크립트 생성 중...');
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${apiKey}&autoload=false`;
        script.async = true;
        
        console.log('📤 생성된 스크립트 URL:', script.src);
        
        script.onload = () => {
            console.log('✅ Kakao SDK 스크립트 로드 완료');
            // kakao 객체가 준비될 때까지 약간 대기
            setTimeout(() => {
                if (window.kakao && window.kakao.maps) {
                    console.log('✅ window.kakao.maps 확인됨, renderMap 호출');
                    renderMap();
                } else {
                    console.error('❌ SDK는 로드되었지만 window.kakao.maps가 없습니다');
                    console.error('window.kakao:', window.kakao);
                }
            }, 100);
        };
        
        script.onerror = (error) => {
            console.error('❌❌❌ Kakao SDK 로드 실패 ❌❌❌');
            console.error('에러 이벤트:', error);
            console.error('에러 타입:', error.type);
            console.error('실패한 URL:', script.src);
            console.error('API 키 값:', apiKey);
            console.error('브라우저에서 해당 URL을 직접 열어보세요:', script.src);
        };
        
        document.head.appendChild(script);
        console.log('📤 스크립트 태그가 DOM에 추가됨');
    }, [renderMap]);

    const initKakaoMap = useCallback(() => {
        console.log('🗺️ 카카오맵 초기화 시작');
        fetch('/api/config', {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(response => {
            console.log('📡 API 응답:', response.status);
            return response.json();
        })
        .then(config => {
            console.log('🔑 설정 받음:', config);
            if (config.kakaoApiKey) {
                console.log('✅ API 키 확인됨, SDK 로드 시작');
                loadKakaoMapSDK(config.kakaoApiKey);
            } else {
                console.error('❌ API 키가 없습니다');
            }
        })
        .catch(error => {
            console.error('❌ 지도 로드 실패:', error);
        });
    }, [loadKakaoMapSDK]);

    useEffect(() => {
        console.log('🔄 useEffect 실행됨');
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        cardsRef.current.forEach(card => {
            if (card) {
                card.style.opacity = '0';
                card.style.transform = 'translateY(30px)';
                card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                observer.observe(card);
            }
        });

        // Kakao Map initialization
        initKakaoMap();

        return () => observer.disconnect();
    }, [initKakaoMap]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'phone') {
            // Auto-format phone number
            let formattedValue = value.replace(/[^0-9]/g, '');
            if (formattedValue.length <= 3) {
                formattedValue = formattedValue;
            } else if (formattedValue.length <= 7) {
                formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3);
            } else if (formattedValue.length <= 11) {
                formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3, 7) + '-' + formattedValue.slice(7);
            } else {
                formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3, 7) + '-' + formattedValue.slice(7, 11);
            }
            setFormData({ ...formData, [name]: formattedValue });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const showMessage = (text, type) => {
        setFormMessage({ text, type });
        setTimeout(() => {
            setFormMessage({ text: '', type: '' });
        }, 5000);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (!formData.name || !formData.email || !formData.phone || !formData.subject || !formData.message) {
            showMessage('모든 필수 항목을 입력해주세요.', 'error');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            showMessage('올바른 이메일 주소를 입력해주세요.', 'error');
            return;
        }

        const phoneRegex = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$|^[0-9]{10,11}$/;
        if (!phoneRegex.test(formData.phone.replace(/\s/g, ''))) {
            showMessage('올바른 연락처를 입력해주세요. (예: 010-1234-5678)', 'error');
            return;
        }

        showMessage('전송 중...', 'info');

        fetch('/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...formData,
                timestamp: new Date().toISOString()
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showMessage(data.message, 'success');
                setFormData({
                    name: '',
                    company: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            } else {
                showMessage(data.message, 'error');
            }
        })
        .catch(error => {
            console.error('Form submission error:', error);
            showMessage('문의 전송 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.', 'error');
        });
    };

    return (
        <section id="contact" className="section contact-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">CONTACT US</span>
                    <h2 className="section-title">문의하기</h2>
                    <p className="section-description">
                        프로젝트에 대해 언제든지 문의해주세요<br />
                        신속하고 정확하게 답변 드리겠습니다
                    </p>
                </div>
                
                <div className="contact-container">
                    <div className="contact-info">
                        <div className="contact-info-card" ref={el => cardsRef.current[0] = el}>
                            <div className="contact-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <h4>주소</h4>
                            <p>전라남도 담양군 무정면<br />성덕길 29-11</p>
                        </div>
                        
                        <div className="contact-info-card" ref={el => cardsRef.current[1] = el}>
                            <div className="contact-icon">
                                <i className="fas fa-phone-alt"></i>
                            </div>
                            <h4>전화</h4>
                            <p>02-1234-5678<br />평일 09:00 - 18:00</p>
                        </div>
                        
                        <div className="contact-info-card" ref={el => cardsRef.current[2] = el}>
                            <div className="contact-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <h4>이메일</h4>
                            <p>yc7974@naver.com<br />kooksob@naver.com</p>
                        </div>
                        
                        <div className="contact-info-card" ref={el => cardsRef.current[3] = el}>
                            <div className="contact-icon">
                                <i className="fas fa-globe"></i>
                            </div>
                            <h4>웹사이트</h4>
                            <p>www.gracetech.co.kr<br />협력사: IF Software</p>
                        </div>
                    </div>
                    
                    <div className="contact-form-wrapper">
                        <form id="contactForm" className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">
                                    <i className="fas fa-user"></i> 이름 *
                                </label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    name="name" 
                                    required 
                                    placeholder="성함을 입력해주세요"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="company">
                                    <i className="fas fa-building"></i> 회사명
                                </label>
                                <input 
                                    type="text" 
                                    id="company" 
                                    name="company" 
                                    placeholder="회사명을 입력해주세요"
                                    value={formData.company}
                                    onChange={handleChange}
                                />
                            </div>
                            
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="email">
                                        <i className="fas fa-envelope"></i> 이메일 *
                                    </label>
                                    <input 
                                        type="email" 
                                        id="email" 
                                        name="email" 
                                        required 
                                        placeholder="이메일을 입력해주세요"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label htmlFor="phone">
                                        <i className="fas fa-phone"></i> 연락처 *
                                    </label>
                                    <input 
                                        type="tel" 
                                        id="phone" 
                                        name="phone" 
                                        required 
                                        placeholder="연락처를 입력해주세요"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="subject">
                                    <i className="fas fa-tag"></i> 문의 유형 *
                                </label>
                                <select 
                                    id="subject" 
                                    name="subject" 
                                    required
                                    value={formData.subject}
                                    onChange={handleChange}
                                >
                                    <option value="">문의 유형을 선택해주세요</option>
                                    <option value="pcb-design">PCB 설계 문의</option>
                                    <option value="pcb-production">PCB 양산 문의</option>
                                    <option value="software">소프트웨어 개발 문의</option>
                                    <option value="integrated">통합 솔루션 문의</option>
                                    <option value="partnership">협력 제안</option>
                                    <option value="other">기타 문의</option>
                                </select>
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="message">
                                    <i className="fas fa-comment-dots"></i> 문의 내용 *
                                </label>
                                <textarea 
                                    id="message" 
                                    name="message" 
                                    rows="5" 
                                    required 
                                    placeholder="문의하실 내용을 상세히 입력해주세요"
                                    value={formData.message}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                            
                            <button type="submit" className="btn btn-primary btn-submit">
                                <i className="fas fa-paper-plane"></i> 문의 보내기
                            </button>
                        </form>
                        
                        {formMessage.text && (
                            <div id="formMessage" className={`form-message ${formMessage.type}`} style={{ display: 'block' }}>
                                {formMessage.text}
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="map-container">
                    <div id="map" className="map"></div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
